import { RootState } from '@react-three/fiber';

type EventState = Pick<RootState, 'events' | 'setEvents'>;

export function setReactThreeFiberEventsEnabled(state: EventState, enabled: boolean) {
  if (state.events.enabled === enabled) return;

  state.setEvents({ enabled });
  state.events.update?.();
}
